/* eslint-disable */
const THEME_STORAGE_KEY = 'theme'

function readSavedTheme () {
  try {
    const saved = window.localStorage.getItem(THEME_STORAGE_KEY)
    if (saved === 'dark' || saved === 'light') return saved
  } catch (error) {
    // localStorage недоступен (приватный режим и т.п.) — не критично
  }
  return 'light'
}

function applyTheme (theme) {
  document.documentElement.setAttribute('data-theme', theme)
}

const initialTheme = readSavedTheme()
applyTheme(initialTheme)

export default {
  state: {
    theme: initialTheme
  },
  mutations: {
    setTheme (state, theme) {
      state.theme = theme
      applyTheme(theme)
      try {
        window.localStorage.setItem(THEME_STORAGE_KEY, theme)
      } catch (error) {
        // не критично, просто не сохранится между визитами
      }
    }
  },
  actions: {
    toggleTheme (ctx) {
      ctx.commit('setTheme', ctx.state.theme === 'dark' ? 'light' : 'dark')
    }
  }
}
